import { array } from "prop-types";
import { toast } from "react-toastify";
import { AUDITING_TEMPLATE } from "config/apiEndPoint";
import { GET, POST } from "config/api.config";

export const getAuditingTemplateList = async (data = array()) => {
  try {
    const url = data?._Id
      ? `${AUDITING_TEMPLATE.GET_AUDITING_TEMPLATE_LIST}/${data?._Id}`
      : AUDITING_TEMPLATE.GET_AUDITING_TEMPLATE_LIST;
    const response = await GET(url, data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

export const submitAuditingTemplateData = async (data = array()) => {
  try {
    const response = await POST(AUDITING_TEMPLATE.SUBMIT_AUDITING_TEMPLATE, data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};
